import request from '@/found/utils/request';
import Form from '@/found/components/form';
import {
  createBasicChargeAmountRule,
  getAdjustmentFieldState,
  getBasicChargeAmountValidation,
  isConsumerTopUp,
} from './adjustmentRules';

export default {
  extends: Form,
  components: {},
  data() {
    return {
      formFunctionCode: 'red_packet_pool_adjustment_form',
    };
  },
  methods: {
    beforeSetRule(rules) {
      const nextRules = Array.isArray(rules) ? rules.slice() : [];
      if (!nextRules.some((item) => item.field === 'basicChargeAmount')) {
        const changeAmountIndex = nextRules.findIndex((item) => item.field === 'changeAmount');
        const basicChargeAmountRule = createBasicChargeAmountRule(false);
        if (changeAmountIndex === -1) {
          nextRules.push(basicChargeAmountRule);
        } else {
          nextRules.splice(changeAmountIndex + 1, 0, basicChargeAmountRule);
        }
      }
      return nextRules;
    },
    setRule(item) {
      const v = item;
      if (item.field === 'changeAmount') {
        item.props = {
          ...item.props,
          min: 0,
          precision: 2,
        };
      }
      if (item.field === 'basicChargeAmount') {
        item.props = {
          ...item.props,
          controls: false,
          min: 0,
          precision: 2,
        };
      }
      if (item.field === 'changeType') {
        const changeHandler = item.on && item.on.change;
        item.on = {
          ...item.on,
          change: (value) => {
            if (typeof changeHandler === 'function') changeHandler(value);
            this.updateAdjustmentFields(value);
          },
        };
      }
      if (item.field === 'remark') {
        item.props = {
          ...item.props,
          autosize: { minRows: 4, maxRows: 8 },
        };
      }
      return v;
    },
    formComplete() {
      this.updateAdjustmentFields(this.getFieldValue('changeType'));
    },
    updateAdjustmentFields(changeType) {
      const row = (this.formConfig && this.formConfig.row) || {};
      const state = getAdjustmentFieldState(row, changeType);
      const amountRule = this.getRule('changeAmount');
      const basicChargeAmountRule = this.getRule('basicChargeAmount');

      if (amountRule) {
        this.updateRules({
          changeAmount: {
            title: state.amountTitle,
            props: {
              placeholder: state.amountTitle,
            },
          },
        });
      }
      if (basicChargeAmountRule) {
        this.hiddenFields(!state.showBasicChargeAmount, 'basicChargeAmount');
        this.updateRules({
          basicChargeAmount: {
            props: {
              required: state.basicChargeAmountRequired,
            },
            validate: getBasicChargeAmountValidation(state.basicChargeAmountRequired),
          },
        });
        if (!state.showBasicChargeAmount) {
          this.setValue({ basicChargeAmount: '' });
        }
      }
    },
    submit() {
      const formData = this.getFormData();
      if (formData) {
        if (!isConsumerTopUp(this.formConfig.row, formData.changeType)) {
          delete formData.basicChargeAmount;
        }
        formData.id = this.formConfig.row.id;
        const url = '/tax/v1/redPooolAccount/addAcountAmount';
        const params = { ...formData };
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
